import { GUIDELINES } from '../guidelines';

// Static reference for the instructor during a run: the wording of the VAs, nothing derived
// from the running scenario. No props: it never changes while the panel is open.
export function GuidelinesPanel() {
  return (
    <div className="space-y-2">
      {GUIDELINES.map((g) => (
        <details key={g.id} className="rounded border border-neutral-800 p-2">
          <summary className="cursor-pointer font-medium">{g.title}</summary>
          <p className="mt-1 text-xs text-neutral-500">{g.meta}</p>
          <p className="mt-2 whitespace-pre-wrap text-neutral-300">{g.text}</p>
        </details>
      ))}
    </div>
  );
}
